<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-3.14,792.5l3.64,3.64l3.63-3.64l-3.63-3.63L-3.14,792.5z M-0.41,802.5v-2.35l-2.72-2.72l-1.17,1.17l-1.29-1.29l1.17-1.18
	l-2.72-2.72H-9.5v-1.82h2.35l2.73-2.73l-1.18-1.18l1.29-1.28l1.17,1.17l2.72-2.72v-2.36h1.82v2.35l2.73,2.73l1.17-1.17l1.28,1.28
	l-1.17,1.17l2.73,2.73h2.35v1.82H8.14l-2.72,2.73l1.17,1.17l-1.28,1.29l-1.17-1.17l-2.73,2.73v2.34H-0.41z M0.5,798.49l5.99-5.99
	l-5.99-5.99l-5.99,5.99L0.5,798.49z"/>
</svg>

</template>